module.exports = __webpack_public_path__ + "img/avatar-48.1a77e9b3.png";